import React from 'react';

export default class Page9 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToBeInnovative');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt wide_page">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>Further Information
                                            </div>

                                            <p>If you found this tool useful then you are likely to find the
                                                following tools both insightful and relevant: </p>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToThinkAboutProblemsLaterally')}
                                                        className="link_color thought button-link-redirect">How to think about
                                                        problems laterally </div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToImproveProcesses')}
                                                        className="link_color thought button-link-redirect">How to improve
                                                        processes </div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToGetTheMostOutOfYourself')}
                                                        className="link_color thought button-link-redirect">How to get the most
                                                        out of yourself </div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToReframeProblems')}
                                                        className="link_color thought button-link-redirect">How to reframe
                                                        problems.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title referencepad"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ul className="greenbullet-list1 septor">
                                                <li><span>1.</span> Osvath, M., &amp; Karvonen, E. (2012).
                                                    Spontaneous Innovation for Future Deception in a Male
                                                    Chimpanzee. PloS one, 7(5).
                                                </li>
                                                <li><span>2.</span> Pearn, M., Roderick, C. &amp; Mulrooney,
                                                    C. (1995). Learning Organizations in Practice.
                                                    Maidenhead: McGraw Hill.
                                                </li>
                                            </ul>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}